import { render } from "./PromotedSection.vue?vue&type=template&id=4a0d4aab&scoped=true&ts=true"
import script from "./PromotedSection.vue?vue&type=script&lang=ts"
export * from "./PromotedSection.vue?vue&type=script&lang=ts"

import "./PromotedSection.vue?vue&type=style&index=0&id=4a0d4aab&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0d4aab"]])

export default __exports__